module.exports = __webpack_public_path__ + "media/1x1/gb-sct-31ef8bcf.svg";